import React from 'react'

import type { MenuRecipeNutritionalInformation } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { useNumPortions } from 'hooks/basket/useNumPortions'
import { NutritionDisclaimerText } from 'routes/Menu/components/Detail/NutritionDisclaimerText'
import { SectionPanel } from 'routes/Menu/components/Detail/SectionPanel'

import { NutritionInfo } from './NutritionInfo'

type RecipeNutritionProps = {
  nutritionalInformation?: MenuRecipeNutritionalInformation
  loading: boolean
}

export const RecipeNutrition = ({ nutritionalInformation, loading }: RecipeNutritionProps) => {
  const { numPortions } = useNumPortions()

  return (
    <SectionPanel>
      <NutritionInfo nutritionValues={nutritionalInformation} loading={loading} />
      <NutritionDisclaimerText numPortions={numPortions} />
    </SectionPanel>
  )
}
